import { Injectable } from '@angular/core';
import { RADIO_PLAN_DESC } from '@app/core/models/Radio';
import { RoleOperators } from '@app/core/services/role-helper.service';
import { Subject } from 'rxjs';

export interface ModelNav {
  id: string;
  type: 'item' | 'collapse';
  title?: string;
  translate?: string;
  icon?: string;
  url?: string;
  function?: any;
  children?: ModelNav[];
  hidden?: boolean;
  exactMatch?: boolean;
  roles?: RoleOperators | string;
  notOnMobile?: boolean;
  lockedUntilPlan?: RADIO_PLAN_DESC;
  isAdminRoute?: boolean;
  isSuperuserRoute?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FuseNavigationService {
  flatNavigation: any[] = [];

  onItemCollapsed: Subject<any> = new Subject();
  onItemCollapseToggled: Subject<any> = new Subject();

  /**
   * Get flattened navigation array
   */
  getFlatNavigation(navigation: ModelNav[]) {
    for (const navItem of navigation) {
      if (navItem.type === 'item') {
        this.flatNavigation.push({
          title: navItem.title,
          type: navItem.type,
          icon: navItem.icon || false,
          url: navItem.url,
        });

        continue;
      }

      if (navItem.type === 'collapse' || navItem.type === 'group') {
        if (navItem.children) {
          this.getFlatNavigation(navItem.children);
        }
      }
    }

    return this.flatNavigation;
  }
}
